var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Notice"},[_c('van-notice-bar',{attrs:{"text":_vm.conText,"left-icon":"volume-o"}})],1)}
var staticRenderFns = []
export { render, staticRenderFns }